export const EVENT_OPERATION_POLL_INTERVAL_MS = 3000

// Async admin operations are acknowledged with REQUEST_SENT and confirmed later
// on the socket. When that completion message is late or lost, the operator is
// left waiting although the operation already landed. This poller re-reads the
// narrow projection until `isComplete` recognises the persisted result, or until
// it is cancelled by the socket completion, the operation deadline or unmount.
export const createCompletionPoller = ({
  read,
  isComplete,
  intervalMs = EVENT_OPERATION_POLL_INTERVAL_MS,
}) => {
  let cancelled = false
  let timer = null
  let settle

  const promise = new Promise(resolve => {
    settle = resolve
  })

  const finish = outcome => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    settle(outcome)
  }

  const tick = async () => {
    timer = null
    let result
    try {
      result = await read()
    } catch (error) {
      result = undefined
    }
    if (cancelled) return

    let completed = false
    try {
      completed = result !== undefined && Boolean(isComplete(result))
    } catch (error) {
      completed = false
    }
    if (completed) {
      finish({ status: "completed", result })
      return
    }

    timer = setTimeout(tick, intervalMs)
  }

  timer = setTimeout(tick, intervalMs)

  return {
    promise,
    cancel: () => {
      if (cancelled) return
      cancelled = true
      finish({ status: "cancelled" })
    },
  }
}
